import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { DprFreeTextFieldReport } from '@report/models';

@Component({
  selector: 'app-report-free-text-fields',
  templateUrl: './report-free-text-fields.component.html',
  styleUrls: ['./report-free-text-fields.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportFreeTextFieldsComponent {
  @Input({ required: true }) freeTextFieldSubTabs: DprFreeTextFieldReport[];
  @Input({ required: true }) enableFreeTextFieldListLayout: boolean;
  @Input({ required: true }) customName: string;
}
